import React from 'react';

const CookiePolicy: React.FC = () => {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'Politique des Cookies',
            description: 'Politique des cookies de Let\'s Try Bet',
          }),
        }}
      />

      <div className="min-h-screen pt-20">
        <section className="py-20">
          <div className="container mx-auto px-4 max-w-4xl">
            <h1 className="text-5xl font-bold text-white mb-4">Politique des Cookies</h1>
            <p className="text-dark-muted mb-8">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>

            <div className="space-y-8 text-dark-muted leading-relaxed">
              <div>
                <h2 className="text-2xl font-bold text-white mb-4">1. Qu'est-ce qu'un Cookie ?</h2>
                <p>
                  Un cookie est un petit fichier texte stocké sur votre appareil lorsque vous
                  visitez un site web. Les cookies permettent au site de mémoriser vos préférences
                  et d'améliorer votre expérience de navigation.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">2. Types de Cookies Utilisés</h2>
                <div className="space-y-4">
                  <div>
                    <h3 className="text-xl font-semibold text-white mb-2">Cookies Essentiels</h3>
                    <p>
                      Ces cookies sont nécessaires au fonctionnement du site. Ils incluent les
                      cookies de session et de sécurité.
                    </p>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-white mb-2">Cookies Analytiques</h3>
                    <p>
                      Nous utilisons ces cookies pour comprendre comment les visiteurs utilisent
                      notre site, ce qui nous aide à l'améliorer.
                    </p>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-white mb-2">Cookies de Préférences</h3>
                    <p>
                      Ces cookies mémorisent vos choix (langue, région) pour personnaliser votre
                      expérience.
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">3. Gestion des Cookies</h2>
                <p className="mb-3">
                  Vous pouvez contrôler et gérer les cookies de plusieurs façons :
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Via les paramètres de votre navigateur</li>
                  <li>Via notre bannière de consentement aux cookies</li>
                  <li>En supprimant les cookies déjà stockés</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">4. Cookies Tiers</h2>
                <p>
                  Certains cookies peuvent être placés par des services tiers (analytics,
                  publicité). Ces cookies sont soumis aux politiques de confidentialité de ces
                  tiers.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">5. Durée de Conservation</h2>
                <p>
                  Les cookies de session sont supprimés à la fermeture de votre navigateur. Les
                  cookies persistants restent sur votre appareil jusqu'à leur expiration ou jusqu'à
                  ce que vous les supprimiez.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">6. Contact</h2>
                <p>
                  Pour toute question concernant notre utilisation des cookies, n'hésitez pas à
                  nous contacter.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default CookiePolicy;

